import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { UserContext } from "../contexts/UserContext";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 18, color: "white" }} spin />
);

const Login = () => {
  const { login } = useContext(UserContext);
  const [load, setLoad] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mailErr, setMailErr] = useState("");
  const [passErr, setPassErr] = useState("");

  const key = "successLogin";
  const onSuccessMessage = () => {
    message.loading({ content: "Loading...", key });
    setTimeout(() => {
      message.success({
        content: "Login Successfully.",
        key,
        duration: 2,
      });
    }, 700);
  };

  const handleSubmit = (e) => {
    setLoad(true);
    const logData = { email, password };
    login(logData)
      .then(() => {
        setTimeout(() => {
          onSuccessMessage();
        }, 300);
      })
      .catch((err) => {
        if (err === "Incorrect Password.") {
          setPassErr(err);
        } else setMailErr(err);
        setLoad(false);
      });
    e.preventDefault();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <div className="w-full max-w-xs">
        <div className="flex items-start justify-center mb-5 text-blue-500">
          <UserOutlined className="text-4xl mr-5" />
          <p className="text-2xl text-center m-0 p-0">
            Sign In to <span className="font-bold">MEMMiFシ</span>
          </p>
        </div>
        <form
          className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-5"
          onSubmit={handleSubmit}
        >
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="email"
            >
              Email Address
            </label>
            <input
              required
              className={`bg-gray-100 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                mailErr ? "border-red-500" : ""
              }`}
              id="email"
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {mailErr ? (
              <p className="text-red-500 text-xs italic mt-3">{mailErr}</p>
            ) : null}
          </div>
          <div className="mb-6">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="password"
            >
              Password
            </label>
            <input
              required
              className={`bg-gray-100 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline ${
                passErr ? "border-red-500" : ""
              }`}
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {passErr ? (
              <p className="text-red-500 text-xs italic">{passErr}</p>
            ) : null}
          </div>
          <div className="flex items-center justify-between">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline h-10 w-24 flex justify-center items-center"
              type="submit"
              disabled={load}
            >
              {load ? (
                <Spin indicator={antIcon} />
              ) : (
                <p className="m-0 p-0">LOGIN</p>
              )}
            </button>

            <Link
              className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
              to="/register"
            >
              OR REGISTER ?
            </Link>
          </div>
        </form>
        <p className="text-center text-gray-500 text-xs">
          &copy;2020 Memmify. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Login;
